import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  grid-template-rows: 1fr 1fr;

  canvas {
    border: 1px solid #445;
    margin-top: 10px;
    height: 800px;
    width: 1000px;
  }

  video {
    border: 1px solid #445;
    width: 600px;
    height: 400px;
  }

  > div {
    border: 1px solid #445;
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #333;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const Ready = styled.div`
  position: absolute;
  top: 5px;
  left: 5px;
  width: 5px;
  height: 5px;
  background-color: green;
`;
